import { createStore } from "vuex"
import { StoreInterface } from "@/modules/store"
import { actions } from "@/utils/constants"
import { HttpService } from "@/services/httpService"
import { StorageService } from "@/services/storageService"
import { LoginRequest, LoginResponse } from "@/modules/api"
import axios from "axios"
import router from "@/router"


export const store = createStore<StoreInterface>({
	state: {
		user: {
			isLogged: false,
			tokens: {
				jwt: undefined,
				refresh: undefined
			},
			user: undefined,
			error: {
				isError: false,
				message: undefined
			}
		}
	},
	mutations: {
		[actions.LOGIN_SUCCESS](state: StoreInterface, data: LoginResponse) {
			state.user.isLogged = true;
			state.user.tokens.jwt = data.data.jwtToken
			state.user.tokens.refresh = data.data.refreshToken;
			state.user.user = data.data.user;
			state.user.error.isError = false;
		},
		[actions.LOGOUT](state: StoreInterface) {
			state.user.user = undefined;
			state.user.isLogged = false;
			state.user.tokens.jwt = undefined;
			state.user.tokens.refresh = undefined;
			state.user.error.isError = false;
		},
		[actions.LOGIN_ERROR](state: StoreInterface, data?: { errorMessage?: string }) {
			state.user.error.isError = true;
			state.user.error.message = data?.errorMessage;
		}
	},
	actions: {
		startup({ commit }) {
			const storageService = StorageService.instance;
			const jwtToken = storageService.getJWTToken();
			const refreshToken = storageService.getRefreshToken();
			const user = storageService.getCurrentUser();

			if (jwtToken && refreshToken && user) {
				const body: LoginResponse = {
					data: {
						jwtToken: jwtToken,
						refreshToken: refreshToken,
						user: user,
					},
					success: "ok"
				};
				commit(actions.LOGIN_SUCCESS, body);
				return;
			}

			commit(actions.LOGOUT);
			return;
		},
		async login({ commit }, userData: LoginRequest) {
			if (userData && userData.email && userData.password) {
				const httpClient = HttpService.instance;
				const storageService = StorageService.instance;

				storageService.setUseLocalStorage(userData.rememberMe);

				try {
					const response = await httpClient.post({url: '/login', data: { email: userData.email, password: userData.password, target: "universiadi" }});
					const responseBody = response.data as LoginResponse;

					storageService.setTokens(responseBody.data.jwtToken, responseBody.data.refreshToken);
					storageService.setUser(responseBody.data.user);
					commit(actions.LOGIN_SUCCESS, responseBody);
					return { success: true }
				} catch (error) {
					if (axios.isAxiosError(error)) {
						commit(actions.LOGIN_ERROR, { errorMessage: error.response?.data.message ?? "login-error" })
						throw new Error("login-error");
					} else {
						commit(actions.LOGIN_ERROR)
						throw error;
					}
				}
			} else {
				commit(actions.LOGIN_ERROR)
				return null
			}
		},
		logout({ commit }) {
			const storageService = StorageService.instance;
			storageService.clear();

			commit(actions.LOGOUT);
			router.push("/login");
		},
	},
	getters: {
		isLogged: (state) => {
			return state.user.isLogged
		},
		currentUser: (state) => {
			return state.user.user
		},
		error: (state) => {
			return state.user.error;
		}
	},
})
